export const kpiData = [
  {name: 'ResponsivenessSeller', translationKey: 'component.invoice.kpis.seller.seller'},
  {name: 'ResponsivenessDebtor', translationKey: 'component.invoice.kpis.seller.debtor'}
];
